module.exports = __webpack_public_path__ + "img/light_1.252c3118.png";